import { Check } from "lucide-react";

const steps = [
  "Project Info",
  "Upload Files",
  "Manufacturing Process",
  // "Select Centre",
  // "Expert Consultation",
  "Review & Submit",
];

export default function StepIndicator({ currentStep }) {
  return (
    <div className="rounded-xl border bg-card text-card-foreground shadow p-4 mb-6 overflow-x-auto">
      <div className="flex items-center min-w-max" style={{justifyContent:"space-around"}}>
        {steps.map((label, i) => {
          const stepNum = i + 1;
          const isDone = stepNum < currentStep;
          const isCurrent = stepNum === currentStep;
          return (
            <div key={label} className="flex items-center" style={{display:"contents"}}>
              <div className="flex items-center gap-2">
                <div
                  className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold shrink-0 ${
                    isDone
                      ? "bg-green-500 text-white"
                      : isCurrent
                      ? "bg-indigo-600 text-white"
                      : "bg-gray-100 text-gray-400"
                  }`}
                >
                  {isDone ? <Check className="w-4 h-4" /> : stepNum}
                </div>
                <span
                  className={`text-sm whitespace-nowrap ${
                    isCurrent
                      ? "font-bold text-gray-900"
                      : isDone
                      ? "font-medium text-gray-700"
                      : "text-gray-400"
                  }`}
                >
                  {label}
                </span>
              </div>
              {stepNum < steps.length && (
                <div
                  className={`h-px w-10 mx-3 ${
                    isDone ? "bg-green-500" : "bg-gray-200"
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}